import { Link, useNavigate } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import React, { useEffect, useState } from "react";
import ShimmerLoader from "../../loading";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";
import IsAddProd from "../../assets/Dashboard/IsAddProd.svg";
import IsMachineCode from "../../assets/Dashboard/IsMachineCode.svg";
import IsCashierSetup from "../../assets/Dashboard/IsCashierSetup.svg";
import IsAddUser from "../../assets/Dashboard/IsAddUser.svg";
import { checkPermission } from "../../Utils/permissionHelper";

const OnboardingData = () => {
  const { t } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [loading, setLoading] = useState(true);
  const [userOnboarding, setUserOnboarding] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    CheckUserOnboarding();
  }, []);

  const CheckUserOnboarding = async () => {
    try {
      const res1 = await getUserOnboarding(company_id);

      if (res1?.result[0].status_code == 200) {
        setUserOnboarding(res1?.result[0]);
      } else {
        setUserOnboarding({});
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const values = {
    1: {
      icon: IsAddProd,
      heading: "Add Product",
      subHeading: "",
      bgcolor: "#F0FBFF",
      textcolor: "#1F2937",
      isDone: userOnboarding?.update_inventory,
      route: "/inventory/",
      // route: "/inventory/InventoryOnboard",

    },
    2: {
      icon: IsMachineCode,
      heading: "Weighing Scale",
      subHeading: "(Add weighing scale product code)",
      bgcolor: "#E8FDF2",
      textcolor: "#1F2937",
      isDone: userOnboarding?.weighing_scale,
      route: "/inventory",
    },
    3: {
      icon: IsCashierSetup,
      heading: "Cashier Setup",
      subHeading: "",
      bgcolor: "#FFF4EB",
      textcolor: "#1F2937",
      isDone: userOnboarding?.cashier_setup,
      route: "/settings/cashiersetup",
    },
    4: {
      icon: IsAddUser,
      heading: "Add User",
      subHeading: "",
      bgcolor: "#ECFCFF",
      textcolor: "#0F172A",
      isDone: userOnboarding?.add_user,
      route: "/settings/usermanagement",
    },
    5: {
      icon: IsAddUser,
      heading: "Delivery Company",
      subHeading: "",
      bgcolor: "#ECFCFF",
      textcolor: "#0F172A",
      isDone: userOnboarding?.delivery_company,
      route: "/settings/cashiersetup",
    },
  };

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
        <Navbar heading="Onboarding" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className="flex justify-end mx-4 mt-3">
                <button
                  className="w-44 h-10 bg-primaryBlue text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2"
                  onClick={() => navigate('/dashboard')}
                >
                  <span>{t("Go to Dashboard")}</span>
                </button>
              </div>
              <div
                className={` mt-10 w-11/12 self-center grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 "xl:grid-cols-5"
                    }`}
              >
                {Object.values(values).map((val, index) => (
                  <div
                    key={index}
                    className={`rounded-2xl pt-6 pb-4 shadow-sm transition-transform transform hover:scale-[1.02] hover:shadow-lg cursor-pointer  ${val.isDone ? "bg-[rgba(232,255,216,0.6)]" : "bg-white"
                      }`}
                    // style={{ backgroundColor: val.bgcolor }}
                    // onClick={() =>
                    //   val.heading === "Add Product"
                    //     ? navigate(val.route, { state: { openChoice: true } })
                    //     : (val.heading === "Weighing Scale" ? navigate(val.route, { state: { pageOption: 4 } }) : navigate(val.route))
                    // }
                    onClick={() => {
                      if (val.heading === "Add Product") {
                        if (checkPermission("/inventory")) {
                          navigate(val.route, { state: { openChoice: true } });
                        } else {
                          console.warn("You do not have permission to access /inventory");
                        }
                      } else if (val.heading === "Weighing Scale") {
                        navigate(val.route, { state: { pageOption: 4 } });
                      } else {
                        navigate(val.route);
                      }
                    }}

                  >
                    <div className="flex flex-col items-center ">
                      <img src={val.icon} alt="icon" className="w-10 h-10" />
                      <p className="text-base text-gray-700 truncate text-primaryBlue font-semibold mt-3">
                        {t(val.heading)}
                      </p>
                      <p className=" text-sm text-gray-700 truncate font-medium">
                        {t(val.subHeading)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OnboardingData;
